import { Badge, BadgeProps } from '@chakra-ui/react'
import { ReactNode } from 'react'

import { getDbStatusText, getStatusColor } from '../../utils/component-utils'

export const AdminBadge = ({
  children,
  colorScheme = 'gray',
  variant = 'solid',
  ...props
}: BadgeProps & { children: ReactNode }) => (
  <Badge
    colorScheme={colorScheme}
    variant={variant}
    fontSize="9px"
    lineHeight="14px"
    px="6px"
    py="1px"
    borderRadius="4px"
    letterSpacing="0.02em"
    {...props}
  >
    {children}
  </Badge>
)

export const StatusBadge = ({ status }: { status: string }) => {
  return (
    <AdminBadge colorScheme={getStatusColor(status)}>
      {getDbStatusText(status)}
    </AdminBadge>
  )
}
